import DatabaseModel from './DatabaseModel.js';

var Pais = Object.create(DatabaseModel);

Pais.model = 'pais';
Pais.modelFront = 'paises';

export default Pais;